import FileSaver from 'file-saver';
import { createApiAction } from '@saucelabs/sl-util-redux';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as api from './api';
import { CSV } from './constants';
import * as types from './types';
import { generateReportName } from './utils';

export const getOrganizationActivity = createApiAction(
  types.GET_ORGANIZATION_ACTIVITY,
  (payload, meta, dispatch, getState) => {
    const orgId = getState().user.get('organization').id;
    return api.getOrganizationActivity(payload).then(({ data }) => data[orgId]);
  },
);

export const getTeamsActivity = createApiAction(
  types.GET_TEAMS_ACTIVITY,
  ({ since, teamIds }, meta, dispatch, getState) => {
    const orgId = getState().user.get('organization').id;
    return api.getTeamsActivity({ orgId, since, teamIds });
  },
);

export const getGroupsActivity = createApiAction(
  types.GET_GROUPS_ACTIVITY,
  ({ groupIds, since }, meta, dispatch, getState) => {
    const orgId = getState().user.get('organization').id;
    return api.getGroupsActivity({ groupIds, orgId, since });
  },
);

export const downloadGroupActivityCsv = createApiAction(
  types.DOWNLOAD_GROUP_ACTIVITY_CSV,
  ({ name, groupIds, since }, meta, dispatch, getState) => {
    const orgId = getState().user.get('organization').id;
    return api.getGroupsActivity({ format: CSV, orgId, since, groupIds })
      .then(({ data }) => FileSaver.saveAs(new Blob([data]), generateReportName({
        rootSection: name,
        reportType: 'tests',
      })))
      .catch(() => dispatch(notificationActions.notifyDanger('Something went wrong with CSV creation')));
  },
);

export const downloadTeamActivityCsv = createApiAction(
  types.DOWNLOAD_TEAM_ACTIVITY_CSV,
  ({ name, since, teamIds }, meta, dispatch, getState) => {
    const orgId = getState().user.get('organization').id;
    return api.getTeamsActivity({ format: CSV, orgId, since, teamIds })
      .then(({ data }) => FileSaver.saveAs(new Blob([data]), generateReportName({
        rootSection: name,
        reportType: 'tests',
      })))
      .catch(() => dispatch(notificationActions.notifyDanger('Something went wrong with CSV creation')));
  },
);

export const downloadUserActivityCsv = createApiAction(
  types.DOWNLOAD_USER_ACTIVITY_CSV,
  ({ since, username }, meta, dispatch) => (
    api.getUserActivity({ format: CSV, since, username })
      .then(({ data }) => FileSaver.saveAs(new Blob([data]), generateReportName({
        rootSection: username,
        reportType: 'tests',
      })))
      .catch(() => dispatch(notificationActions.notifyDanger('Something went wrong with CSV creation')))
  ),
);
